import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Suspense, lazy } from "react";
import InteractionGate from "@/components/ui/InteractionGate";

const PartsCindyChat = lazy(() => import("@/components/parts/PartsCindyChat"));

function PartsCatalogLayout() {
  return (
    <>
      <Outlet />
      <InteractionGate>
        <Suspense fallback={null}>
          <PartsCindyChat />
        </Suspense>
      </InteractionGate>
    </>
  );
}

export const Route = createFileRoute("/parts-catalog")({
  component: PartsCatalogLayout,
});
